export * from './tariff-viewer.component';
